import { filter, isNumber, map } from 'lodash'

import config from '@/config'

const resetPlayer = (state) => {
  state.playerLocationX = 0
  state.playerLocationY = 0

  return state
}
export default {

  state: resetPlayer({}),

  getters: {

    playerLocationX ({ playerLocationX }) {
      return playerLocationX
    },

    playerLocationY ({ playerLocationY }) {
      return playerLocationY
    },

    playerLocation (state, { playerLocationX, playerLocationY }) {
      return {
        x: playerLocationX,
        y: playerLocationY
      }
    },

    playerRadioIds (state, { playerLocationX, playerLocationY, radios }) {
      return map(filter(radios, (radio) => {
        return radio.locationX === playerLocationX && radio.locationY === playerLocationY
      }), 'id')
    }

  },

  mutations: {

    resetPlayer,

    updatePlayer (state, { playerLocationX, playerLocationY }) {
      if (isNumber(playerLocationX)) {
        state.playerLocationX = Math.min(Math.max(playerLocationX, 0), config.maxMapX)
      }

      if (isNumber(playerLocationY)) {
        state.playerLocationY = Math.min(Math.max(playerLocationY, 0), config.maxMapY)
      }
    }

  },

  actions: {

    movePlayerTo ({ commit }, { x, y }) {
      commit('updatePlayer', {
        playerLocationX: x,
        playerLocationY: y
      })
    }

    // movePlayerWest ({ dispatch, getters }) {
    //   dispatch('movePlayerTo', {
    //     x: getters.playerLocationX - 1
    //   })
    // },

    // movePlayerEast ({ dispatch, getters }) {
    //   dispatch('movePlayerTo', {
    //     x: getters.playerLocationX + 1
    //   })
    // },

    // movePlayerNorth ({ dispatch, getters }) {
    //   dispatch('movePlayerTo', {
    //     y: getters.playerLocationY - 1
    //   })
    // },

    // movePlayerSouth ({ dispatch, getters }) {
    //   dispatch('movePlayerTo', {
    //     y: getters.playerLocationY + 1
    //   })
    // }

  }

}
